export default __webpack_public_path__ + "static/wchc-23a92a15d75ba24d3f4a8c830e3a78ee.png";